import { render, staticRenderFns } from "./addEditDrawer.vue?vue&type=template&id=06685b72&scoped=true"
import script from "./addEditDrawer.vue?vue&type=script&lang=js"
export * from "./addEditDrawer.vue?vue&type=script&lang=js"
import style0 from "./addEditDrawer.vue?vue&type=style&index=0&id=06685b72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06685b72",
  null
  
)

export default component.exports